export default "__VITE_ASSET__Cuo6b0oX__"